import { TranslatedText } from "@/components/common/text";

export const ModalDisclaimer = ({ text }) => {
    return (
        <div className="mt-2 mb-2 text-xs/[19px] text-cm-p-text-primary bg-[rgba(254,252,232,1)] px-3 py-2 rounded-lg">
            <TranslatedText text={text} />
        </div>
    );
};
